<template>
  <!-- 只有当没有父级或父级展开时，才需要渲染，以此优化性能 -->
  <a-menu-item
    :key="item.id"
    :title="item.title"
    :disabled="item.user && userid != item.user.id"
    v-if="item.expandshow || item.expandshow === undefined"
    class="ehf-menu-item"
  >
    <div class="catalog_item">
      <div class="catalog_left">
        <slot name="left" :item="item" :userid="userid"></slot>
      </div>
      <div class="catalog_center">
        <span class="catalog_title" :title="item.title">{{ item.title }}</span>
      </div>
      <div class="catalog_right">
        <slot name="right" :item="item" :userid="userid"></slot>
      </div>
    </div>
  </a-menu-item>
</template>

<script>
  import { isNull } from '@/utils'
  import { mapGetters } from 'vuex'
  export default {
    name: 'MenuItem',
    props: {
      item: {
        type: Object,
        default() {
          return null
        },
      },
    },
    computed: {
      ...mapGetters({
        userid: 'user/userid',
      }),
    },
    data() {
      return {
        addKnowledgeModalShow: false,
        defaultItem: {},
        bookId: null,
        check_type: null,
      }
    },
    methods: {
      handleMenuClick(type, item) {
        console.log(type, item)
      },
    },
    created() {
      let query = this.$route.query
      if (!isNull(this.query) && Object.keys(this.query).length > 0) {
        query = this.query
      }
      this.bookId = query.book_id
      this.check_type = query.check_type
    },
  }
</script>
